// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3plto","inputDescription":"styles_inputDescription__3nz5-"};